import React from 'react';

import {HeadingText} from 'app/components/general/HeadingText';

import {LaneSerializedType} from 'sweet-types';

interface Props {
  lane: LaneSerializedType;
}

export function StepLane({lane}: Props): JSX.Element | null {
  return lane != null ? (
    <div>
      <StepLaneStructure>{lane.name}</StepLaneStructure>
    </div>
  ) : null;
}

export function StepLaneStructure({children}: {children: React.ReactNode}) {
  return (
    <HeadingText size="0.8rem">
      <i className="fas fa-road mt-1 mr-1" /> {children}
    </HeadingText>
  );
}
